import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const NOISE =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

// Reusable cinematic dark hero — CSS orbital rings + champagne glow + grain.
export const PageHero = ({ overline, title, blurb, align = "left", children }) => (
  <section className="relative overflow-hidden bg-[#0A0A0A] text-[#FAF9F6]" data-testid="page-hero">
    {/* orbital rings */}
    <motion.div
      aria-hidden
      className="pointer-events-none absolute top-1/2 h-[44rem] w-[44rem] -translate-y-1/2 rounded-full border border-[#C5A059]/15 md:-right-40 md:left-auto -right-56"
      animate={{ rotate: 360 }}
      transition={{ duration: 100, repeat: Infinity, ease: "linear" }}
    >
      <div className="absolute inset-10 rounded-full border border-[#C5A059]/10" />
      <div className="absolute inset-24 rounded-full border border-[#C5A059]/8" />
      <div className="absolute left-1/2 top-0 h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-[#C5A059] shadow-[0_0_20px_5px_rgba(197,160,89,0.5)]" />
    </motion.div>

    {/* champagne glow */}
    <div
      className="pointer-events-none absolute right-0 top-1/2 h-[38rem] w-[38rem] -translate-y-1/2 translate-x-1/3 rounded-full"
      style={{ background: "radial-gradient(circle, rgba(197,160,89,0.22), transparent 62%)" }}
    />
    {/* grain */}
    <div className="pointer-events-none absolute inset-0 opacity-[0.14] mix-blend-overlay" style={{ backgroundImage: NOISE }} />
    {/* vignette */}
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_38%,#0A0A0A_92%)]" />

    <div className="relative z-10 mx-auto max-w-[1500px] px-5 py-24 md:px-10 md:py-36">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease }}
        className={align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}
      >
        {overline && <p className="font-body text-[0.7rem] uppercase tracking-[0.32em] text-[#C05C42]">{overline}</p>}
        <h1 className="mt-5 font-serif text-[clamp(2.8rem,7vw,5.5rem)] font-light leading-[0.95] tracking-tight text-[#FAF9F6]">
          {title}
        </h1>
        {blurb && <p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-[#FAF9F6]/60 md:text-lg">{blurb}</p>}
        {children && <div className="mt-8">{children}</div>}
      </motion.div>
    </div>

    {/* dark → light fade */}
    <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-[#FAF9F6]" />
  </section>
);

export default PageHero;
